import { BlockStatus, BlockCategory, Company, DashboardStats, LeadStage, Task, TaskPriority, TaskStatus, User, UserRole, WeeklyBlockInstance, WeeklyBlockTemplate, ActivityLog, Workspace, Interaction, ContentPost, ContentPlatform, ContentFormat, ContentStatus, AgendaEvent, AgendaEventType, Project, ProjectStatus, ServiceType, Course, CourseAudience, CourseEdition, DocumentLink, DocumentType, TrainingModule, LibraryResource, Notification, AppView } from "./types";

// El acceso lo gestiona Supabase Auth (ver components/Auth.tsx).
// Aquí NO va ninguna credencial: todo lo que se escriba en este archivo acaba
// dentro del JavaScript que se sirve a cualquiera que abra la web.

// Google API Configuration
// Prioritize the VITE_ prefixed variable which is standard for Vite
export const GOOGLE_CLIENT_ID = (import.meta as any).env?.VITE_GOOGLE_CLIENT_ID || "711206353803-j53vb4a8iavmr8sjcaib9spsroaicf73.apps.googleusercontent.com";
export const GOOGLE_SCOPES = "https://www.googleapis.com/auth/gmail.send https://www.googleapis.com/auth/calendar";

export const WORKSPACES: Workspace[] = [
  { id: "ws-1", name: "SDAI Principal", role: UserRole.OWNER },
  { id: "ws-2", name: "Incubadora B2B", role: UserRole.SOCIO },
];

export const MOCK_STATS: DashboardStats = {
  newLeads: 0,
  interactions: 0,
  pendingToday: 0,
  postsCreated: 0,
  postsPublished: 0,
  blocksCompletedPercent: 0,
};

export const MOCK_NOTIFICATIONS: Notification[] = [];

// --- PROMPTS ---

export const CRM_ANALYSIS_PROMPT = `# ROL
Actúa como un Analista de Negocios Senior y Experto en Ventas B2B. Tu trabajo es analizar sitios web de empresas y extraer inteligencia comercial para preparar una reunión de ventas.

# TAREA
Analiza el texto o la URL que te proporcionaré a continuación. Extrae la información clave y formatéala ESTRICTAMENTE como un objeto JSON válido, sin texto adicional antes ni después (ni markdown \`\`\`json).

# ESTRUCTURA DE SALIDA (JSON)
Debes rellenar este esquema. Si no encuentras un dato, usa null o una cadena vacía, pero no inventes.

{
  "company": {
    "name": "Nombre comercial corto",
    "website": "URL principal (si la tienes)",
    "sector": "Industria principal (ej: Logística, SaaS, Retail)",
    "size_hint": "Estimación de tamaño (ej: 'Pequeña', 'Multinacional', '10-50 empleados')"
  },
  "summary": "Resumen ejecutivo de 3 líneas. Qué hacen, para quién y cuál es su propuesta de valor única.",
  "pain_points": [
    "Punto de dolor 1 (Problema probable que tengan)",
    "Punto de dolor 2",
    "Punto de dolor 3"
  ],
  "opportunities_sdai": [
    "Oportunidad 1 (Cómo un servicio de Automatización/IA les ayudaría)",
    "Oportunidad 2 (Ej: 'Tienen un blog abandonado -> Oportunidad de Contenido IA')"
  ],
  "processes_to_automate": [
    "Proceso 1 (Ej: 'Atención al cliente parece manual')",
    "Proceso 2"
  ],
  "icebreakers": [
    "Frase rompehielo 1 (Basada en una noticia reciente, premio o curiosidad de su web)",
    "Frase rompehielo 2"
  ],
  "recommended_channel": "linkedin", // Elige entre: linkedin, email, call. Basado en si son muy digitales o tradicionales.
  "score_0_10": 7 // Tu valoración subjetiva (0-10) de cuánto encajan como cliente para una consultora de IA, basado en su aparente sofisticación digital.
}

# CONTEXTO DEL SERVICIO (SDAI)
SDAI es una agencia que vende:
1. Automatización de procesos (Make/n8n).
2. Implementación de IA en empresas.
3. Formación en IA.
Usa esto para rellenar los campos de "opportunities_sdai".

# INPUT
[AQUÍ PEGARÁS EL TEXTO DE LA WEB O LA URL]`;

// --- CLEAN DATA ---
const today = new Date().toISOString().split('T')[0];

export const MOCK_COMPANIES: Company[] = [];

import { Contact } from './types';

export const MOCK_CONTACTS: Contact[] = [];

export const MOCK_INTERACTIONS: Interaction[] = []; // Cleared interactions to avoid ID conflicts

export const MOCK_PROJECTS: Project[] = []; // Cleared projects as user requested fresh start with new companies

export const MOCK_TASKS: Task[] = []; // Cleared tasks

export const WEEKLY_TEMPLATE: WeeklyBlockTemplate[] = [];

export const WEEKLY_INSTANCES: WeeklyBlockInstance[] = [];

export const MOCK_POSTS: ContentPost[] = [];

export const MOCK_EVENTS: AgendaEvent[] = [];

export const MOCK_MODULES: TrainingModule[] = [];

export const MOCK_RESOURCES: LibraryResource[] = [];
export const MOCK_COURSES: Course[] = [];
export const MOCK_EDITIONS: CourseEdition[] = [];
export const MOCK_DOCUMENTS: DocumentLink[] = [];

// Helper to export today's blocks for Layout/FocusMode (Deprecated usage in code, but kept for safe type export)
export const TODAY_BLOCKS = WEEKLY_INSTANCES.filter(b => b.date === today);
export const RECENT_ACTIVITY: ActivityLog[] = [];
